import { Link } from 'react-router-dom';
import { hospitals } from '@/mocks/home';
import { fetchHospitalList } from '@/services/hospital';
import { adaptHospitals } from '@/services/adapters';
import { useRequest } from '@/hooks/useRequest';
import SectionHeading from '@/components/base/SectionHeading';

const HOME_LIMIT = 4;

export default function HospitalsSection() {
  // 接口失败时降级为 mock 数据
  const { data: hospitalList } = useRequest(
    () => fetchHospitalList({ pageIndex: 1, pageSize: HOME_LIMIT }).then((res) => adaptHospitals(res.list)),
    { fallback: hospitals.slice(0, HOME_LIMIT) },
  );

  // 无数据时整段隐藏，避免出现只有标题与按钮的空板块
  if (hospitalList.length === 0) return null;

  return (
    <section id="hospitals" className="scroll-mt-24 w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="医院专科"
          title="名院名科汇聚，中西医共护健康"
          description="协同全国著名三甲中医、中西医结合医院，推广医院知名医生、优势病种、特色方案、适宜技术、院内制剂等，推动优质医疗协同共享。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {hospitalList.map((hospital) => (
            <Link
              key={hospital.id}
              to={`/hospitals/${hospital.id}`}
              className="group flex flex-col sm:flex-row rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="relative w-full sm:w-2/5 h-48 sm:h-auto overflow-hidden shrink-0">
                <img
                  src={hospital.image}
                  alt={hospital.name}
                  title={`${hospital.name} - 合作医院`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex flex-col flex-1 p-5">
                <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 leading-snug text-balance group-hover:text-primary-600 transition-colors">
                  {hospital.name}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {hospital.intro}
                </p>

                <div className="flex flex-wrap items-center gap-2 mt-3">
                  <span className="text-xs text-foreground-400">院内制剂</span>
                  {hospital.preparations.map((item) => (
                    <span
                      key={item.name}
                      className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs"
                    >
                      {item.name}
                    </span>
                  ))}
                </div>

                <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between gap-3">
                  <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-user-star-line text-primary-500"></i>
                    {hospital.doctors.length} 位合作医师
                  </span>
                  <span className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-medium rounded-md border border-primary-200 text-primary-600 group-hover:bg-primary-50 transition-colors whitespace-nowrap">
                    查看详情
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/hospitals"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部合作医院
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}